import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './AuthContext';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const loggedIn = await login(email, password);
      if (loggedIn.mustChangePassword) {
        // Вход по временному паролю из письма — предлагаем сразу задать свой
        navigate('/change-password', { state: { forced: true } });
      } else {
        navigate('/'); // Redirect to homepage after successful login
      }
    } catch (err) {
      setError('Ошибка входа. Проверьте email и пароль.');
    }
  };

  return (
    <div className="login-page">
      <h2>Вход в систему</h2>
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Пароль:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        
        <div className="form-actions">
          <button type="submit" className="btn">Войти</button>
        </div>
      </form>
      
      <div className="register-link">
        <p>Нет аккаунта? <Link to="/register">Зарегистрироваться</Link></p>
        <p><Link to="/forgot-password">Забыли пароль?</Link></p>
      </div>
    </div>
  );
};

export default Login;
